export default "__VITE_ASSET__C$R3QgOZ__"